module.exports = __webpack_public_path__ + "assets/img/search_example.c81644d5.png";